'use client';

import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export interface UiModPortalBaseProps {
  children?: React.ReactNode;
  getContainer?: () => HTMLElement | Element | DocumentFragment | null;
}

/**
 * Обертка react.createPortal
 *
 * Исключает проблемы связанные c SSR
 */
export function UiModPortalBase({
  children,
  getContainer
}: UiModPortalBaseProps) {
  const [isMount, setIsMount] = useState(false);

  useEffect(() => {
    setIsMount(true);
  }, []);

  return isMount
    ? createPortal(children, getContainer?.() || document.body)
    : null;
}
